import APIAmplify from '@aws-amplify/api';
import { cloneDeep } from 'lodash';
import Utils from '@/common/utils/utils';
import S3PathUtil from '@/common/utils/S3PathUtil';
import localStorageUtil from '@/common/utils/localStorageUtil';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import CorporationUtils from '@/common/utils/CorporationUtils';
import McpUtils from '@/common/utils/mcpUtils';
import Constant from '@/common/constant/Constant';
import McpServerApi from '@/common/constant/api/McpServerApi';

import {onCorporationUpdated } from '@/graphql/subscriptions';

import { getProjectById, getProjectIdListUserIsB2C, isCurrentProjectIsCustomerOfProjectTarget } from '@/service/projectService';
import { getCorporationById } from '@/service/organizationService';
import { getViewById, updateViewData } from '@/service/viewService';
import { getTicketById } from '@/service/ticketService';
import { uploadImagesTmpOnAiChat, uploadFilesTmpOnAiChat } from '@/service/attachFileService';

import { hasKnowledgeChatPermissionInChatThread } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { checkedUsageRangeProject } from '@/component/common/layout/gNav/handler/MenuHandler';
import { userAccessShareLinkTicket } from '../../chatThread/handler/MessageHandler';
import { initTicketKnowledgePrompt } from '@/component/common/modal/AIPrompt/HanlderAIPrompt';
import { getPublicAPI, updatePublicAPI } from '@/service/publicService';
import { getMCPServer } from '@/service/mcpServerService';
import trI18n from '@/common/utils/trI18n';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const updateTabNameAfterSendMessage = (
    newOutline,
    panelId,
    setPanelList,
    tabId
) => {
    setPanelList(prevPanelList => {
        let currentPanelList = cloneDeep(prevPanelList);
        if (Utils.isEmptyArray(currentPanelList)) return prevPanelList;

        let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
        if (currentPanelIndex === -1) return prevPanelList;

        let currentPanel = currentPanelList[currentPanelIndex];
        if (Utils.isEmptyArray(currentPanel.tabList)) return prevPanelList;

        let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
        if (currentTabIndex === -1) return prevPanelList;

        // Update ticket outline
        currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = newOutline;
        currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = newOutline;

        return currentPanelList;
    });
};

export const getProjectInfo = async (
    API,
    projectId,
    setProjectInfo,
    corporationDetail,
    setTitleTicket,
    setPromptInternalTicket,
    setPromptExternalTicket,
    setBasicPrompt,
    filterKnowledgeListData,
    setIsReloadPage,
    setCorporationSelected,
    projectInUseId,
    setIsUsingKnowledgeService,
    setProjectInuseDetail
) => {
    if (!projectId) return;

    if (projectId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
        // Set usingKnowledgeService
        let corporationLimitValue = corporationDetail?.limitValue;
        let inviterLimitValue = corporationDetail.inviterSetting
            ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting)
            : {};

        let isCurrentCorpUsingKnowledgeService =
            corporationLimitValue?.knowledgeService === Constant.PDF_FUNCTION.ON ||
            inviterLimitValue.knowledgeService === Constant.PDF_FUNCTION.ON;
        setIsUsingKnowledgeService(isCurrentCorpUsingKnowledgeService);

        setCorporationSelected(corporationDetail.id);
        return;
    }

    const projectDetail = await getProjectById(API, projectId);

    if (Utils.isEmptyObject(projectDetail)) {
        return;
    }

    const isOpenTabChatAI = await checkPermissionOpenTabChatAI(API, projectId, corporationDetail, projectDetail);

    if(!isOpenTabChatAI) {
        setIsReloadPage(true);
    }

    const resBasicPrompt = await initTicketKnowledgePrompt(
        APIAmplify,
        corporationDetail.id !== projectDetail?.affiliationOrganization
            ? projectDetail?.affiliationOrganization
            : corporationDetail.id,
        projectId,
        corporationDetail.id
    );

    const isUsingKnowledgeService = resBasicPrompt?.isUsingKnowledgeService;
    setIsUsingKnowledgeService(isUsingKnowledgeService)

    const projectSetting = Utils.convertJSONDataToObject(projectDetail.projectSetting);
    const chatAISetting = projectSetting?.chatAISetting;

    const linkPromptInternal = chatAISetting?.internalSetting?.basicPrompt;
    const linkPromptExternal = chatAISetting?.externalSetting?.basicPrompt;

    let uriTicketId = '';
    if (linkPromptInternal) {
        uriTicketId  = destructLinkPrompt(linkPromptInternal);
    }
    const titleBasicSetting = resBasicPrompt?.infoPrompt?.titleBasicSetting;
    let titleTicket = titleBasicSetting?.internalSetting;
    let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, projectDetail.name);
    if (projectDetail.id !== projectInUseId) {
        titleTicket = titleBasicSetting?.externalSetting;
        let corpAffiliation = corporationDetail;
        if (corpAffiliation.id !== projectDetail?.affiliationOrganization) {
            corpAffiliation = await getCorporationById(
                API,
                projectDetail?.affiliationOrganization
            );

            const corporationName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                corpAffiliation.name
            );
            projectName = `${projectName} (${corporationName})`;
        } else {
            projectName = `${projectName}`;
        }

        if (linkPromptExternal) {
            uriTicketId  = destructLinkPrompt(linkPromptExternal);
        }
    }

    if (projectDetail.id === projectInUseId) {
        projectName = trI18n('CM-LABEL-PRJ-IN-USE');
    }

    projectDetail.projectName = projectName;

    const listPrompt = resBasicPrompt?.listPrompt;

    const promptInternalTicket = listPrompt && !Utils.isEmptyArray(listPrompt) ?
        listPrompt.find(p => p.title.trim() === titleBasicSetting?.internalSetting.trim()) : {};
    setPromptInternalTicket(promptInternalTicket);

    const promptExternalTicket = listPrompt && !Utils.isEmptyArray(listPrompt) ?
        listPrompt.find(p => p.title.trim() === titleBasicSetting?.externalSetting.trim()) : {};
    setPromptExternalTicket(promptExternalTicket);

    setProjectInfo(projectDetail);
    setTitleTicket(titleTicket);

    setBasicPrompt(uriTicketId);
    setCorporationSelected(projectDetail?.affiliationOrganization);
};

const destructLinkPrompt = linkInput => {
    const destructLink = linkInput.split('/');
    if (destructLink.length !== 8) {
        return '';
    }

    const uriTicketId = destructLink[7];
    return uriTicketId
};

/**
 * resetChatAISearchCondition
 * update props resetSearchCondition of tab chat to true
 * @param {*} panelList
 * @param {*} setPanelList
 * @param {*} panelId
 * @param {*} tabId
 * @returns
 */
export const resetChatAISearchCondition = (
    panelList, 
    setPanelList, 
    panelId, 
    tabId,
    API,

    viewSelectedKnowledge,
    drilldownDataForLog,
    totalTickets,
    
    userDetail,
    projectInuseDetail,
    corporationDetail,
    tabNameChatAI,
    corporationSelected,
    projectIdKnowledgeSelected,
    prevToggleUsingKnowledgeTicketList,
    setToggleUsingKnowledgeTicketList,
    initHitNumber,
    selectedMcpServers 
) => {

    let currentPanelList = cloneDeep(panelList);
    if (Utils.isEmptyArray(currentPanelList)) return;
    let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
    if (currentPanelIndex === -1) return;

    let currentPanel = currentPanelList[currentPanelIndex];

    if (Utils.isEmptyArray(currentPanel.tabList)) return;
    let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
    if (currentTabIndex === -1) return;

    currentPanelList[currentPanelIndex].tabList[
        currentTabIndex
    ].component.props.filterKnowledgeListData.resetSearchCondition = prevToggleUsingKnowledgeTicketList;
    
    // comment for now
    // // Save current MCP servers selection
    // currentPanelList[currentPanelIndex].tabList[
    //     currentTabIndex
    // ].component.props.filterKnowledgeListData.listSelectedMcp = selectedMcpServers;

    setPanelList([...currentPanelList]);

    setToggleUsingKnowledgeTicketList(!prevToggleUsingKnowledgeTicketList);
};

/**
 * handleToggleUsingBasicPrompt
 * update ON/OFF props usingBasicPrompt of tab chat
 * @param {*} panelList
 * @param {*} setPanelList
 * @param {*} panelId
 * @param {*} tabId
 * @returns
 */
export const handleToggleUsingBasicPrompt = (
    panelList,
    setPanelList,
    panelId,
    tabId,
    toggleUsingBasicPrompt,
    setToggleUsingBasicPrompt
) => {
    let currentPanelList = cloneDeep(panelList);
    if (Utils.isEmptyArray(currentPanelList)) return;
    let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
    if (currentPanelIndex === -1) return;

    let currentPanel = currentPanelList[currentPanelIndex];

    if (Utils.isEmptyArray(currentPanel.tabList)) return;
    let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
    if (currentTabIndex === -1) return;

    // Update ticket outline
    currentPanelList[currentPanelIndex].tabList[
        currentTabIndex
    ].component.props.filterKnowledgeListData.usingBasicPrompt = !toggleUsingBasicPrompt;
    setPanelList([...currentPanelList]);

    setToggleUsingBasicPrompt(!toggleUsingBasicPrompt);
};

export const checkPermissionOpenTabChatAI = async (API, projectId, corporationInUseDetail, projectInUseDetail) => {
    if (!projectId) return true;

    if (projectId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
        return !!corporationInUseDetail.limitValue?.usingChatAI;
    }

    const projectDetails = projectId === projectInUseDetail.id
        ? projectInUseDetail
        : await getProjectById(API, projectId);

    if (Utils.isEmptyObject(projectDetails)) return false;

    const affiliationOrgId = projectDetails.affiliationOrganization;
    const isSameOrg = affiliationOrgId === corporationInUseDetail.id;

    const affiliationOrganization = isSameOrg
        ? corporationInUseDetail
        : await getCorporationById(API, affiliationOrgId);

    if (Utils.isEmptyObject(affiliationOrganization)) return false;

    return await checkChatAIAccessByCorporation(API, affiliationOrganization, corporationInUseDetail);
};

const checkChatAIAccessByCorporation = async (API, corporation, corporationInUse) => {
    const { contractType, inviter, limitValue } = corporation;

    if (
        contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM &&
        !limitValue?.usingChatAI
    ) {
        return false;
    }

    if (
        [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(contractType)
    ) {
        let inviterCorp = corporationInUse;
        if (inviter !== corporationInUse.id) {
            inviterCorp = await getCorporationById(API, inviter);
        }

        return !!inviterCorp?.limitValue?.usingChatAI;
    }

    return true;
};

export const checkPermissionOpenTabChatAIOnServer = async (API, corporationInuseId, projectInuseId, userWorkspace) => {
    try {
        const params = {
            getApiType: Constant.CHECK_VIEW_TICKET_PERMISSION_METHOD.CHECK_PERMISSION_OPEN_TAB_CHAT_AI,
            corporationInuseId,
            projectInuseId,
            userWorkspace
        };

        const checkPermissionResult = await getPublicAPI(null, params);
        const { success, payload } = checkPermissionResult;
    
        return {
            isHasPermission: Boolean(success),
            payload: Utils.convertJSONDataToObject(payload)
        }
    } catch (error) {
        console.log('checkPermissionOpenTabChatAIOnServer error :', error );
        return {
            isHasPermission: false,
            payload: {}
        }
    }

};

export const onSubscriptionEventUpdateCorporation = ({
    subscriptionCorpId,
    setIsReloadPage,
    setCorporationDetail
}) => {
    if (!subscriptionCorpId) return;

    let subscription = APIAmplify.graphql({
        query: onCorporationUpdated,
        variables: {id: subscriptionCorpId}
    }).subscribe({
        next: resData => {
            let corporationData = resData?.value?.data.onCorporationUpdated;
            let limitValue = Utils.convertJSONDataToObject(corporationData.limitValue);
            if (
                limitValue.chatAI !== Constant.STATUS_SERVICE_PERMISSION.ON ||
                limitValue?.usingChatAI !== Constant.STATUS_SERVICE_PERMISSION.ON
            ) {
                setIsReloadPage(true);
            }
            
            try {
                setCorporationDetail(preStateCorporation => {
                    // Check contractType từ latest state thay vì closure
                    if (
                        preStateCorporation.contractType !==
                        Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                    ) {
                        return preStateCorporation;
                    }
                    const currentInviterSetting = Utils.convertJSONDataToObject(
                        preStateCorporation?.inviterSetting
                    );
                    const newInviterCorporationLimitValue = Utils.convertJSONDataToObject(
                        corporationData?.limitValue
                    );
                    return {
                        ...preStateCorporation,
                        inviterSetting: JSON.stringify({
                            ...currentInviterSetting,
                            kBoard: newInviterCorporationLimitValue?.kBoard,
                            usingKBoard: newInviterCorporationLimitValue?.usingKBoard
                        })
                    };
                });
            } catch (error) {
                console.log('setCorporationDetail error :>> ', error);
            }
        },
        error: err => {
            console.log('onSubscriptionEventUpdateCorporation err', err);
        }
    });

    return subscription;
};


export const isValidSearchConditionData = async (
    API,
    projectInuse,
    otherProjectId,
    projectTarget,
    viewId,
    currentUserDetail = null,
    userPermissionView = null,
    setProjectIdListUserIsB2CAtom = () => {},
    panelList = [],
    setPanelList = () => {}
) => {
    if (otherProjectId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) return true;
    if (!projectInuse || !otherProjectId || !viewId || !projectTarget?.id) {
        return false;
    }

    if (projectInuse.affiliationOrganization === projectTarget.affiliationOrganization) {
        // Validate B2C
        if (projectInuse.type === Constant.PROJECT_TYPE.CUSTOMER) {
            let projectCustomerIdList = await getProjectIdListUserIsB2C(API, currentUserDetail.id);
            setProjectIdListUserIsB2CAtom(!Utils.isEmptyArray(projectCustomerIdList) ? projectCustomerIdList : []);
            let isValid = true;
            if (!projectCustomerIdList || Utils.isEmptyArray(projectCustomerIdList)) {
                isValid = false;
            }
            let isValidCustomerInTargetProject = projectCustomerIdList.includes(projectTarget.id);
            if (
                !isValidCustomerInTargetProject ||
                Utils.isEmptyObject(isValidCustomerInTargetProject)
            )
                isValid = false;
            if (!isValid) {
                return false;
            }
        }

        const [viewInfo, newestTargetProjectInfo, newestTargetCorpInfo] = await Promise.all([
            getViewById(API, viewId),
            getProjectById(API, projectTarget.id),
            getCorporationById(API, projectTarget.affiliationOrganization)
        ]);

        const isCheckingValid = isProjectInuseValidRangeWithTargetProject(
            newestTargetProjectInfo,
            newestTargetCorpInfo,
            projectInuse,
            userPermissionView
        );
        if (
            Utils.isEmptyObject(viewInfo) ||
            !isCheckingValid ||
            (viewInfo.status !== Constant.STATUS_VIEW.SHOW && !projectInuse.isProjectManager)
        ) {
            return false;
        }

        if (viewInfo.status !== Constant.STATUS_VIEW.SHOW) {
            // update view when current user is prj manager in target project.
            await updateViewData(API, viewId, {
                status: Constant.STATUS_VIEW.SHOW,
                updator: currentUserDetail.id
            });
        }
    } else {
        const [
            isCurrentProjectIsCustomerOfProjectTargetFlag,
            isProjectTargetIsCustomerOfCurrentProjectFlag,
            viewData,
            newestTargetProjectInfo,
            newestTargetCorpInfo
        ] = await Promise.all([
            isCurrentProjectIsCustomerOfProjectTarget(API, projectInuse.id, otherProjectId),
            isCurrentProjectIsCustomerOfProjectTarget(API, otherProjectId, projectInuse.id),
            getViewById(API, viewId),
            getProjectById(API, projectTarget.id),
            getCorporationById(API, projectTarget.affiliationOrganization)
        ]);

        const isCheckingValid = isProjectInuseValidRangeWithTargetProject(
            newestTargetProjectInfo,
            newestTargetCorpInfo,
            projectInuse,
            userPermissionView
        );

        if (
            (!isCurrentProjectIsCustomerOfProjectTargetFlag &&
                !isProjectTargetIsCustomerOfCurrentProjectFlag) ||
            Utils.isEmptyObject(viewData) ||
            !isCheckingValid ||
            viewData.status !== Constant.STATUS_VIEW.SHOW
        ) {
            return false;
        }
    }

    return true;
};

/**
 * checking project inuse is valid with target project
 * https://new.redmine.ominext.com/issues/112316. TH3
 * @param {*} newestTargetProjectInfo
 * @param {*} newestTargetCorpInfo
 * @param {*} projectInuse
 * @param {*} userPermissionView 
 * @returns boolean
 */
const isProjectInuseValidRangeWithTargetProject = (newestTargetProjectInfo, newestTargetCorpInfo, projectInuse, userPermissionView) => {
    const newestTargetProjectSetting = Utils.convertJSONDataToObject(newestTargetProjectInfo?.projectSetting)
    const targetProjectAIUsageRange = newestTargetProjectSetting?.chatAISetting?.usageRange
    const isTargetProjectTurnOnChatAISettingInProjectInfo = !!targetProjectAIUsageRange?.length
    const isTargetCorpTurnOnChatAISettingInRootCorp = !!newestTargetCorpInfo.limitValue.usingChatAI
    const isTargetCorpTurnOnKnowledgeServiceInRootCorp = !!newestTargetCorpInfo.limitValue.knowledgeService

    let rangeOfProjectInuseWithTargetProject = '';
    if (
        projectInuse.affiliationOrganization === newestTargetProjectInfo.affiliationOrganization
    ) {
        rangeOfProjectInuseWithTargetProject = Constant.AI_SETTING_RANGE.IN_ORG;
        if(projectInuse.id === newestTargetProjectInfo.id) {
            rangeOfProjectInuseWithTargetProject = Constant.AI_SETTING_RANGE.IN_PROJECT;
        }
    } else {
        rangeOfProjectInuseWithTargetProject = Constant.AI_SETTING_RANGE.OUT_ORG;
    }
    
    if (
        [
            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C,
            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER,
            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_SUPPORTED
        ].includes(userPermissionView.type)
    ) {
        rangeOfProjectInuseWithTargetProject = Constant.AI_SETTING_RANGE.OUT_ORG;
    }

    const isUsageRangeInTargetProject = checkedUsageRangeProject(newestTargetProjectInfo, rangeOfProjectInuseWithTargetProject)

    return (
        isTargetProjectTurnOnChatAISettingInProjectInfo &&
        isTargetCorpTurnOnChatAISettingInRootCorp &&
        isTargetCorpTurnOnKnowledgeServiceInRootCorp &&
        isUsageRangeInTargetProject
    );
}

export const updateChatAIInvalidPreconditionStatus = (panelList, setPanelList, panelId, tabId, status) => {
    let currentPanelList = cloneDeep(panelList);
    if (Utils.isEmptyArray(currentPanelList)) return;
    let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
    if (currentPanelIndex === -1) return;

    let currentPanel = currentPanelList[currentPanelIndex];

    if (Utils.isEmptyArray(currentPanel.tabList)) return;
    let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
    if (currentTabIndex === -1) return;

    // Update ticket outline
    currentPanelList[currentPanelIndex].tabList[
        currentTabIndex
    ].component.props.filterKnowledgeListData.isInvalidPrecondition = status || false;
    setPanelList([...currentPanelList]);
};

export const openPromptTicketPanel = async (
    setIsLoading,
    userDetail,
    ticketId,
    projectInuseDetail,
    setIsOpenModalReloadPage,
    addNewPanel,
    setIsOpenAccessDeniedPopup,
    corporationDetail,
    setActionError
) => {
    if (Utils.isEmptyString(ticketId)) return;

    setIsLoading(true);
    
    const ticketDetail = await getTicketById(null, ticketId);

    if (Utils.isEmptyObject(ticketDetail)) {
        setIsLoading(false);
        if(setIsOpenModalReloadPage) setIsOpenModalReloadPage(true);
        if (setIsOpenAccessDeniedPopup) setIsOpenAccessDeniedPopup(true);
        return;
    }

    if (!Utils.isEmptyObject(corporationDetail)) {
        let orgCode = corporationDetail.organizationDomain;
        if (ticketDetail.affiliationOrganization !== corporationDetail.id) {
            let affiliationOrganizationInfo = await getCorporationById(null, ticketDetail.affiliationOrganization);
            orgCode = affiliationOrganizationInfo.organizationDomain;
        }

        const checkPermissionResult = await userAccessShareLinkTicket(
            userDetail?.id,
            ticketId,
            projectInuseDetail?.id,
            orgCode,
            ticketDetail.affiliationProject,
        );

        if (!checkPermissionResult) {
            setIsLoading(false);
            if (setIsOpenAccessDeniedPopup) setIsOpenAccessDeniedPopup(true);
            return;
        }

        const checkPermissionPayload = Utils.convertJSONDataToObject(checkPermissionResult.payload);
        if (!checkPermissionPayload.isHasPermission || !checkPermissionPayload.isEnableKnowledgeService) {
            setIsLoading(false);
            if (!checkPermissionPayload.isEnableKnowledgeService && setActionError) {
                setActionError(trI18n('USER14MSG028'));
                return;
            }

            if (setIsOpenAccessDeniedPopup) setIsOpenAccessDeniedPopup(true);
            return;
        }
    }

    if (userDetail?.id !== ticketDetail?.creator) {
        let isValid = hasKnowledgeChatPermissionInChatThread(
            ticketDetail,
            projectInuseDetail,
            userDetail?.id,
            true
        );

        setIsLoading(false);
        if (!isValid) {
            if (setIsOpenAccessDeniedPopup) {
                setIsOpenAccessDeniedPopup(true);
            } else {
                setIsOpenModalReloadPage(true);
            }
            return;
        }
    }
    setIsLoading(false);
    if (!Utils.isEmptyObject(ticketDetail)) {
        let addNewPanelParam = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            tabId: ticketDetail.id,
            ticketId: ticketDetail.id,
            ticketOutline: ticketDetail.outline,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt)
        }

        if (ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT)
            addNewPanelParam = { ...addNewPanelParam, isDraft: true };
        
        addNewPanel(addNewPanelParam);
    }
};

export const handleToggleUsingKnowledgeTicketList = (
    API,
    panelId,
    tabId,
    panelList,
    setPanelList,

    viewSelectedKnowledge,
    drilldownDataForLog,
    totalTickets,
    
    userDetail,
    projectInuseDetail,
    corporationDetail,
    
    tabNameChatAI,
    corporationSelected,
    projectIdKnowledgeSelected,
    prevToggleUsingKnowledgeTicketList,
    setToggleUsingKnowledgeTicketList,
    initHitNumber,
    selectedMcpServers
) => {

    resetChatAISearchCondition(
        panelList,
        setPanelList,
        panelId,
        tabId,
        API,

        viewSelectedKnowledge,
        drilldownDataForLog,
        totalTickets,

        userDetail,
        projectInuseDetail,
        corporationDetail,
    
        tabNameChatAI,
        corporationSelected,
        projectIdKnowledgeSelected,
        prevToggleUsingKnowledgeTicketList,
        setToggleUsingKnowledgeTicketList,
        initHitNumber,
        selectedMcpServers
    );
};

export const handleUpdateSearchCondition = async ({
    chatThreadId,
    setViewSelectedKnowledge,
    listenOnChangeViewSelectedKnowledge,
    panelList, 
    setPanelList, 
    panelId, 
    tabId,
    enqueueSnackbar,
    viewKnowledgeProjectSelected,
    totalTickets,
    isUsingChatAI,
    destinationPrjId
}) => {
    // check chatAI function
    if (!isUsingChatAI) return;

    // save new viewSelected
    const newViewSelectedKnowledge = {...listenOnChangeViewSelectedKnowledge};

    setViewSelectedKnowledge({
        ...newViewSelectedKnowledge,
        hitNumber: totalTickets
    });

    // update filterKnowledgeListData
    const currentPanelList = cloneDeep(panelList);
    if (Utils.isEmptyArray(currentPanelList)) return;

    const currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
    if (currentPanelIndex === -1) return;

    const currentPanel = currentPanelList[currentPanelIndex];
    if (Utils.isEmptyArray(currentPanel.tabList)) return;

    const currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
    if (currentTabIndex === -1) return;

    const currentFilterData = currentPanel.tabList[currentTabIndex].component.props.filterKnowledgeListData;

    // Build updated filterKnowledgeListData
    const updatedFilterKnowledgeListData = {
        ...currentFilterData,
        viewSelectedId: listenOnChangeViewSelectedKnowledge.id,
        viewSelected: newViewSelectedKnowledge,
        viewStructure: {
            ...Utils.convertJSONDataToObject(listenOnChangeViewSelectedKnowledge.structure),
            visibility: listenOnChangeViewSelectedKnowledge.visibleType
        },
        visibilityKnowledgeAtom: listenOnChangeViewSelectedKnowledge.visibleType,
        projectIdKnowledgeSelected: viewKnowledgeProjectSelected.projectId,
        projectSelectedId: viewKnowledgeProjectSelected.projectId,
        ticketCreatedCorporationId: viewKnowledgeProjectSelected.corporationId,
        ticketCreatedProjectId: destinationPrjId,
        chatThreadId: chatThreadId
    };

    // Apply updated data
    currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.filterKnowledgeListData = updatedFilterKnowledgeListData;
    
    setPanelList([...currentPanelList]);

    enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    // updateAiTabChat
    await updatePublicAPI(null, {
        updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.UPDATE_AI_CHAT_THREAD_DATA,
        aiChatThreadId: chatThreadId,
        filterKnowledgeListData: updatedFilterKnowledgeListData
    });
}

export const onUpdateTabChatConfigurations = (
    setPanelList, 
    panelId, 
    tabId,
    prevUsingChatGptModel,
    setUsingChatGptModel,
    currentListSelectedMcp = [],
    usingReasoningEffort,
    setUsingReasoningEffort
) => {

    setPanelList(prevPanelList => {
        let currentPanelList = cloneDeep(prevPanelList);
        if (Utils.isEmptyArray(currentPanelList)) return prevPanelList;

        let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
        if (currentPanelIndex === -1) return prevPanelList;

        let currentPanel = currentPanelList[currentPanelIndex];
        if (Utils.isEmptyArray(currentPanel.tabList)) return prevPanelList;

        let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
        if (currentTabIndex === -1) return prevPanelList;
        let filterKnowledgeListData =
            currentPanelList[currentPanelIndex]?.tabList[currentTabIndex]?.component?.props
                ?.filterKnowledgeListData;
        const currentModel =
            currentPanelList[currentPanelIndex]?.tabList[currentTabIndex]?.component?.props
                ?.filterKnowledgeListData?.usingChatGptModel;
        let listSelectedMcp =
            currentPanelList[currentPanelIndex]?.tabList[currentTabIndex]?.component?.props
                ?.filterKnowledgeListData?.listSelectedMcp;
        listSelectedMcp = !Utils.isEmptyArray(listSelectedMcp) ? listSelectedMcp : [];

        const currentReasoningEffort =
            currentPanelList[currentPanelIndex]?.tabList[currentTabIndex]?.component?.props
                ?.filterKnowledgeListData?.usingReasoningEffort;
        if (
            currentModel === prevUsingChatGptModel &&
            Utils.isEqualArray(listSelectedMcp, currentListSelectedMcp) &&
            currentReasoningEffort === usingReasoningEffort &&
            filterKnowledgeListData?.hasOwnProperty('listSelectedMcp')
        ) {
            return prevPanelList;
        }

        currentPanelList[currentPanelIndex].tabList[
            currentTabIndex
        ].component.props.filterKnowledgeListData.usingChatGptModel = prevUsingChatGptModel;

        currentPanelList[currentPanelIndex].tabList[
            currentTabIndex
        ].component.props.filterKnowledgeListData.listSelectedMcp = currentListSelectedMcp;

        currentPanelList[currentPanelIndex].tabList[
            currentTabIndex
        ].component.props.filterKnowledgeListData.usingReasoningEffort = usingReasoningEffort;

        return currentPanelList;
    });
    setUsingChatGptModel(prevUsingChatGptModel);
    setUsingReasoningEffort(usingReasoningEffort);
};

export const createTmpUploadedImgs = async (corporationId, projectInuseId, chatThreadId, uploadNewImgFiles, setUploadImgs, setIsUploading) => {
    setIsUploading(true);
    try {
        const path = S3PathUtil.getAiChatUploadsTmpPath(corporationId, projectInuseId, chatThreadId);
        const listImgData = await uploadImagesTmpOnAiChat(path, uploadNewImgFiles);

        if (!Utils.isEmptyArray(listImgData)) {
            // Update state list uploaded img
            setUploadImgs(prev => {
                return prev.map(img => {
                    const match = listImgData.find(item => item.file.id === img.id);
                    if (match) {
                        return {
                            ...img,
                            s3Path: match.file.s3Path,
                            thumbnailInfo: match.thumbnailInfo
                        };
                    }
                    return img;
                });
            });
        }
    } catch (error) {
        console.log('createTmpUploadedImgs error :', error );
    }
    setIsUploading(false);
}

export const createTmpUploadedFiles = async (corporationId, projectInuseId, chatThreadId, uploadNewFiles, setUploadFiles, setIsUploading) => {
    setIsUploading(true);
    try {
        const path = S3PathUtil.getAiChatUploadsTmpPath(corporationId, projectInuseId, chatThreadId);
        const listFileData = await uploadFilesTmpOnAiChat(path, uploadNewFiles);

        if (!Utils.isEmptyArray(listFileData)) {
            // Update state list uploaded files
            setUploadFiles(prev => {
                return prev.map(file => {
                    const match = listFileData.find(item => item.id === file.id);
                    if (match) {
                        return {
                            ...file,
                            s3Path: match.s3Path
                        };
                    }
                    return file;
                });
            });
        }
    } catch (error) {
        console.log('createTmpUploadedFiles error :', error);
    }
    setIsUploading(false);
}

// Fetch AI service options for chatAiPanel
export const fetchChatAiConfigurations = async ({
    corporationInuseDetail,
    projectInuseDetail,
    userId,
    filterKnowledgeListData
}) => {

    // List AI service options
    let aiConfigurations = {
        listChatGptModel: [],
        listMcpInProject: [],
        listSelectedMcp: [],
    };

    try {
        let projectInuseId = projectInuseDetail.id || localStorageUtil.getSelectedProjectId();
        let selectedProjectId = projectInuseId;

        let corporationInuseId = corporationInuseDetail.id || localStorageUtil.getAffiliationOrganization();
        let selectedCorporationId = corporationInuseId;

        if (Utils.getPrefixOfId(filterKnowledgeListData?.projectSelectedId) === Constant.ID_PREFIX.PROJECT) {
            selectedProjectId = filterKnowledgeListData?.projectSelectedId;
        }

        if (Utils.getPrefixOfId(filterKnowledgeListData?.ticketCreatedCorporationId) === Constant.ID_PREFIX.ORGANIZATION) {
            selectedCorporationId = filterKnowledgeListData?.ticketCreatedCorporationId;
        }

        const [selectedProjectDetail, selectedCorporationDetail] = await Promise.all([
            selectedProjectId === projectInuseDetail.id
                ? projectInuseDetail
                : getProjectById(null, selectedProjectId),

            selectedCorporationId === corporationInuseDetail.id
                ? corporationInuseDetail
                : getCorporationById(null, selectedCorporationId)
        ]);

        // 1. Get listChatGptModel
        const listChatGptModel = OpenAiUtil.getListChatGptModelFromCorpDetail(selectedCorporationDetail);
        aiConfigurations.listChatGptModel = listChatGptModel;

        // 2. Get listMcp
        const listMCPOnChatAi = await fetchMcpOnChatAi({
            corporationInuseId,
            projectInuseId,
            userId,
            selectedCorporationDetail,
            selectedProjectDetail
        });
        aiConfigurations.listMcpInProject = listMCPOnChatAi;

        // 3. Get list selected MCP form tabChatAI cache
        if (filterKnowledgeListData?.hasOwnProperty('listSelectedMcp')) {
            let selectedMcpListCache = filterKnowledgeListData.listSelectedMcp || [];
            if (Utils.isEmptyArray(filterKnowledgeListData.listSelectedMcp)) return aiConfigurations;

            // override selected mcp id
            selectedMcpListCache = selectedMcpListCache.map(selectedId => {
                const isLocalMcp = Utils.getPrefixOfId(selectedId) === Constant.ID_PREFIX.MCP_CATALOG;
                if (!isLocalMcp) return selectedId; // mcp server

                // Try parse to check [U] / [P]. Old cache: fallback return prefix = [U]
                const { catId, prefix } = McpUtils.parseLocalMcpScope(selectedId);
                return McpUtils.appendLocalMcpScope(catId, prefix)
            });

            aiConfigurations.listSelectedMcp = selectedMcpListCache.filter(selectedId => {
                // Keep 分析機能 sentinel — it is not a real MCP server, validated separately at submit.
                if (selectedId === Constant.KIBANA_MCP_ID) return true;
                return listMCPOnChatAi.some(mcp => mcp.id === selectedId && Boolean(mcp?.isConnected));
            });
        }

        return aiConfigurations;

    } catch (error) {
        console.log('fetchChatAiConfigurations error >>>', error);
        return aiConfigurations;
    }
}

const fetchMcpOnChatAi = async ({
    corporationInuseId,
    projectInuseId,
    userId,
    selectedCorporationDetail,
    selectedProjectDetail
}) => {
    try {
        if (Utils.isEmptyObject(selectedCorporationDetail) || Utils.isEmptyObject(selectedProjectDetail) || !userId) return [];

        const isCanUsingMCP = CorporationUtils.isCanUsingMCPService(selectedCorporationDetail, selectedProjectDetail);
        if (!isCanUsingMCP) return [];

        let response = await getMCPServer({
            corporationInuse: corporationInuseId,
            projectInuse: projectInuseId,
            getMethod: McpServerApi.MCP_SERVER_GET_METHOD.GET_LIST_MCP_ON_AI_CHAT,
            userId: userId,
            queryParams: JSON.stringify({
                selectedCorporationId: selectedCorporationDetail?.id,
                selectedProjectId: selectedProjectDetail?.id
            })
        });
            
        let listMcpOnChatAi = Utils.convertJSONDataToObject(response?.payload);

        return listMcpOnChatAi || [];
    } catch (error) {
        console.log('fetchMcpOnChatAi error >>>', error);
        return [];
    }
};
